export default "__VITE_ASSET__Bz8sNmme__"